module.exports = __webpack_public_path__ + "img/banner4.0d7af52e.gif";